import { createSlice } from '@reduxjs/toolkit';
import { fetchLoadSearch } from './ActionsSuppleAnnulSlice';

const initialState = {
  search: {
    isLoading: false,
    query: null,
    results: [],
    totalResults: 0,
    totalPages: 0,
    error: null
  }
};

export const SupplementsAnnultments = createSlice({
  name: 'SupplementsAnnultments',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchLoadSearch.pending, (state) => {
      state.search = {
        ...state.search,
        isLoading: true
      };
    });
    builder.addCase(fetchLoadSearch.fulfilled, (state, { payload }) => {
      state.search = {
        ...payload,
        isLoading: false
      };
    });
  },
  reducers: {
    onResetState: (state) => {
      state.search = initialState.search;
    },
    onResetSearch: (state) => {
      state.search = initialState.search;
    },
    onSetResults: (state, { payload }) => {
      state.search = { ...payload };
    }
  }
});

export const { onResetState, onSetResults, onResetSearch } = SupplementsAnnultments.actions;
